import { tokenPrefix } from './tokens';
const AUTH_BACKEND = import.meta.env.VITE_AUTH_BACKEND_URL;
/** POST /auth/jwt/verify → {user_id}. Clears caches if user changed. */
export async function verifyTokenIdentity(token) {
    if (!AUTH_BACKEND || !token)
        return;
    try {
        const res = await fetch(`${AUTH_BACKEND}/auth/jwt/verify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        });
        if (!res.ok)
            return;
        const data = (await res.json());
        const newId = data.user_id != null ? String(data.user_id) : null;
        const prefix = tokenPrefix();
        const stored = localStorage.getItem(prefix + 'token_user_id');
        if (newId && newId !== stored) {
            // wipe per-user caches
            localStorage.removeItem(prefix + 'saved_user_name');
            localStorage.removeItem(prefix + 'saved_user_login');
        }
        if (newId)
            localStorage.setItem(prefix + 'token_user_id', newId);
    }
    catch (e) {
        console.error('verifyTokenIdentity failed', e);
    }
}
